import Head from "next/head";

import { useTranslator } from "@eo-locale/react";

import { Alert } from "@/storybook-components";
import List from "./list";
import Menu from "./menu";
import { filterData } from "@/lib";

import { useAppSelector } from "@/redux/store/hooks";

const App = (): JSX.Element => {
  const { translate } = useTranslator();
  const { error, projects, finder } = useAppSelector((state) => state.projects);
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { name, stylesheetSrc } = queryFilter;

  const projectList = filterData(projects, finder);

  const alertNode = () => {
    return (
      <Alert status="error">{translate("projectFinder.fetchError")}</Alert>
    );
  };

  const projectFinderNode = () => {
    return (
      <div className="ehq-projectFinder">
        <Menu projects={projectList} />
        <List projects={projectList} />
      </div>
    );
  };

  return (
    <>
      <Head>
        <title>{`${name || translate("projectFinder.projectFinder")}`}</title>
        {stylesheetSrc && <link href={stylesheetSrc} rel="stylesheet" />}
      </Head>
      {error ? alertNode() : projectFinderNode()}
    </>
  );
};

export default App;
